import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { IoArrowBack } from "react-icons/io5";
import { errorAlert, successAlert } from "../common/Alert";
import { cancelSubscription, getBookingHistoryAPI, SubscriptionBookingList } from "../../services/Networkcall";
import { Loader } from "../common/Loader";
import moment from "moment";
import Swal from "sweetalert2";

const REASONS = [
    "Too expensive",
    "Switching to a competitor",
    "Temporary need to cut costs",
    "Not using it enough",
    "Please let us know more (optional)",
];

export const CancelReservationModel = ({ show, closeModal, bookingId }) => {

    const [loading, setLoading] = useState(false);
    const [bookings, setbookings] = useState([]);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [selectedReason, setSelectedReason] = useState("");
    const [step, setStep] = useState(1);

    const handleSelectBooking = (booking) => {
        setSelectedBooking(booking?._id || null);
        setStep(2);
    };

    const handleClose = () => {
        setStep(1);
        setSelectedBooking(null);
        setSelectedReason("");
        closeModal();
    };

    const handleCancel = async () => {
        setLoading(true);
        // your cancel API call here
        setLoading(false);
        handleClose();
    };

    const fetchMonthlySubscriptionBooking = async () => {
        setLoading(true);
        try {
            const res = await SubscriptionBookingList();
            if (res?.success) {
                setbookings(res?.data || []);
            } else {
                errorAlert({ message: res?.message || "Failed to fetch bookings" });
            }
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch bookings" })
        } finally {
            setLoading(false);
        }
    }


    const handleCancelReservation = async () => {
        if (!selectedBooking) {
            errorAlert({ message: "Please select a reservation to cancel." });
            return;
        }
        if (!selectedReason) {
            errorAlert({ message: "Please select a reason for cancellation." });
            return;
        }


        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You will not be able to revert this action.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Cancel Reservation",
                cancelButtonText: "No, Go Back",
                dangerMode: true,
                customClass: {
                    popup: "custom-swal-popup",
                    title: "custom-swal-title",
                    htmlContainer: "custom-swal-text",
                    confirmButton: "custom-swal-confirm",
                    cancelButton: "custom-swal-cancel",
                },
            });

            if (!result.isConfirmed) return;

            const payload = { subscriptionId: selectedBooking, reason: selectedReason };
            setLoading(true);

            const res = await cancelSubscription(payload);

            if (res.success) {
                successAlert({ message: res.message || "Reservation cancelled successfully" });
            } else {
                errorAlert({ message: res.message || "Failed to cancel reservation." });
            }
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to cancel reservation." });
        } finally {
            setLoading(false);
            handleClose();
        }
    };


    const handlePauseMembership = () => {
        if (!selectedBooking) {
            errorAlert({ message: "Please select a reservation to pause." });
            return;
        }
        if (!selectedReason) {
            errorAlert({ message: "Please select a reason for pausing." });
            return;
        }
        setLoading(true);
        try {
            // Call your cancellation API here with selectedBooking._id and selectedReason
            // Example:
            // await cancelReservationAPI(selectedBooking._id, selectedReason);
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to cancel reservation." });
        } finally {
            setLoading(false);
            handleClose();
        }
    }

    useEffect(() => {
        if (bookingId) {
            setSelectedBooking(bookingId || null);
            setStep(2);
        }
        else {
            fetchMonthlySubscriptionBooking();
        }
    }, [bookingId])

    return (
        <>

            <Loader show={loading} />
            <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>

                <Modal.Header closeButton>
                    <Modal.Title className="d-flex align-items-center gap-2">
                        {step === 2 && !bookingId && (
                            <IoArrowBack
                                className="cursor-pointer"
                                onClick={() => setStep(1)}
                            />
                        )}
                        <p className="text-center w-100 fw-bold mb-0 align-content-center ">{step === 1 ? "Cancel Reservation" : "Before you Cancel"}</p>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ height: '70vh', overflow: "auto" }}>

                    {/* STEP 1 — BOOKING LIST */}
                    {step === 1 && (
                        <div className="d-flex flex-column gap-3">
                            {bookings?.length > 0 && <small className="text-subtle-danger">select to cancel reservation</small>}
                            {bookings?.length === 0 ? (
                                <p className="text-muted text-center py-3">No active bookings found.</p>
                            ) : (
                                bookings?.map((b, index) => (
                                    <div
                                        key={b?._id}
                                        className={` ${selectedBooking === b?.currentBookings[0]._id ? "border border-primary" : ""} reservation-card rounded-4 p-3 mb-3`}
                                        onClick={() => handleSelectBooking(b)}
                                    >
                                        {/* Header */}
                                        <div className="d-flex align-items-center gap-3">

                                            <div className="flex-grow-1">
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div>
                                                        <h6 className="fw-bold mb-1 reservation-title">
                                                            {b?.currentBookings[0]?.locationInfo?.locationName || ""}
                                                        </h6>

                                                        <p className="text-muted small mb-0 reservation-address">
                                                            {b?.currentBookings[0]?.locationInfo?.locationAddress || ""}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <span className={`badge ${b?.status === "ACTIVE" ? " bg-success" : " bg-danger "}  p-2 text-white`}>
                                                {b?.status}
                                            </span>
                                        </div>

                                        {/* Divider */}
                                        <div className="reservation-divider my-3" />

                                        {/* Info */}
                                        <div className="row g-3">

                                            <div className="col-12">
                                                <div className="reservation-period-box">

                                                    <small className="text-muted d-block mb-2">
                                                        Reservation Period
                                                    </small>

                                                    <div>

                                                        <span className="fw-semibold reservation-date">
                                                            {b?.startDateTime
                                                                ? b?.locationInfo?.timezone
                                                                    ? moment(b.startDateTime).tz(b.locationInfo.timezone).format("MMM DD, hh:mm A")
                                                                    : moment(b.startDateTime).format("MMM DD, hh:mm A")  // fallback: no tz
                                                                : "—"}
                                                        </span>

                                                        <span className="mx-3">-</span>

                                                        <span className="fw-semibold reservation-date">
                                                            {b?.renewalDate
                                                                ? b?.locationInfo?.timezone
                                                                    ? moment(b.renewalDate).tz(b.locationInfo.timezone).format("MMM DD, hh:mm A")
                                                                    : moment(b.renewalDate).format("MMM DD, hh:mm A")  // fallback: no tz
                                                                : "—"}
                                                        </span>


                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="reservation-info-box">
                                                    <table className="table bg-transparent">
                                                        <thead className="bg-transparent">
                                                            <tr>
                                                                <th className="text-muted small bg-light">Booking Id</th>
                                                                <th className="text-muted small bg-light">Truck</th>
                                                                <th className="text-muted small bg-light">Driver</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {bookings[index]?.currentBookings?.map((b, idx) => (
                                                                <tr key={idx} className="bg-light">
                                                                    <td className="small bg-light">{b?._id || "-"}</td>
                                                                    <td className="small bg-light">
                                                                        {b?.vehicleInfo
                                                                            ? `${b.vehicleInfo.vehicleName} (${b.vehicleInfo.licensePlate})`
                                                                            : "-"}
                                                                    </td>
                                                                    <td className="small bg-light">{b?.assignedDriver?.userName || "-"}</td>
                                                                </tr>
                                                            ))}  
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                ))
                            )}
                        </div>
                    )}

                    {/* STEP 2 — CANCEL REASON */}
                    {step === 2 && (
                        <div className="p-2">
                            {/* Warning banner */}
                            <div
                                className="d-flex align-items-start gap-2 rounded-3 p-3 mb-4"
                                style={{ background: "#fff3cd", fontSize: "0.875rem" }}
                            >
                                <span style={{ fontSize: "1.1rem" }}>⚠️</span>
                                <span className="fw-semibold">
                                    We'd like to make sure this is the best decision for your parking needs
                                </span>
                            </div>

                            <p className="fw-bold mb-4">Please let us know why you're leaving</p>

                            {/* Reason list */}
                            <div className="border rounded-3 overflow-hidden mb-4">
                                {REASONS.map((reason) => (
                                    <label
                                        key={reason}
                                        className="d-flex align-items-center gap-3 px-3 py-2 cursor-pointer"
                                        style={{
                                            borderBottom: "1px solid #f0f0f0",
                                            background: selectedReason === reason ? "#f8f9fa" : "white",
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            name="cancel-reason"
                                            value={reason}
                                            checked={selectedReason === reason}
                                            onChange={() => setSelectedReason(reason)}
                                        />
                                        <span style={{ fontSize: "0.9rem" }}>{reason}</span>
                                    </label>
                                ))}
                            </div>

                            {/* Pause section */}
                            {/* <div className="mb-3">
                                <p className="fw-bold mb-1">Still considering? Let's pause your membership.</p>
                                <p className="text-muted" style={{ fontSize: "0.85rem" }}>
                                    Take a break instead of canceling. You can pause your membership for up to 3 months.
                                </p>
                              <Button variant="primary" className="w-100 rounded-3 py-2 mb-2">
                                    Pause Membership
                                </Button>  
                            </div> */}

                            <Button
                                variant="danger"
                                className="w-100 rounded-3 py-2"
                                disabled={!selectedReason || loading}
                                onClick={handleCancelReservation}
                            >
                                {loading ? "Canceling..." : "Yes, I'm Sure. Cancel My Membership"}
                            </Button>
                        </div>
                    )}

                </Modal.Body>
            </Modal>

        </>
    )
}